import { Component, Vue, Prop } from 'vue-property-decorator';
import { applyClasses } from './../../lib';

type Color = 'primary' | 'secondary';
type Variant = 'determinate' | 'indeterminate';
type Classes = {
  root: string | object;
  bar1: string | object;
};

@Component
export default class ClLinearProgress extends Vue {
  /**
   * The classnames of the internal components.
   */
  @Prop({
    type: Object as () => Classes,
    default: () => ({})
  })
  public classes!: Classes;

  @Prop({
    type: String as () => Color,
    default: 'primary',
    validator: x => ['primary', 'secondary'].includes(x)
  })
  public color!: Color;

  @Prop({
    type: String as () => Variant,
    default: 'indeterminate',
    validator: x => ['indeterminate', 'determinate'].includes(x)
  })
  public variant!: Variant;

  @Prop({
    type: Number
  })
  public value!: number;

  applyClasses = applyClasses;
}
